import { log as logger } from '../Log.js';
var log = logger.Logger('PayInvoice');

import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';

import { ErrorWrapper } from '../components/ErrorWrapper.jsx';
import { StorageContext } from './Storage.js';
import { Notifier } from '../Notifier.js';
import { PaymentMethod } from './PaymentMethod.jsx';

import { LoadingSpinner } from '../LoadingSpinner.js';
import { dateFormatOptions } from './constants.js';
import { usePaymentProcessor } from './usePaymentProcessor.js';
import { PurchaseHandler } from './PurchaseHandler.jsx';
import { invoicePurchaseDescription } from './storage_util.js';


// component that handles paying an invoice that has been generated by a user for a third party to pay
function PayInvoice(props) {
	log.debug("PayInvoice");

	log.debug(props);
	const { detectedLocation, invoice, invoiceUser, institutionName, overQuota } = props;
	const { invoiceID, invoiceType, stripeCharge, numUsers, institutionID, storageLevel, created } = invoice;
	
	const [ stripeCustomer, setStripeCustomer ] = useState(props.stripeCustomer);
	const [ pageNotification, setPageNotification ] = useState(null);
	const [ operationPending, setOperationPending ] = useState(false);
	const [ stripeChargeObject, setStripeChargeObject ] = useState(props.stripeChargeObject);
	const [ invoicePaid, setInvoicePaid ] = useState(!!stripeCharge);

	const [ purchase, setPurchase ] = useState({
		invoiceID: invoiceID,
		type: invoiceType,
		storageLevel,
		numUsers,
		institutionID,
		institutionName,
		immediateCharge: true
	});

	// const stripe = window.stripe;// useStripe();

	log.debug({invoice, stripeCustomer, purchase}, 4);

	let paymentResultCallback = (result) => {
		log.debug("paymentResultCallback");
		setPageNotification(result);
		if (result.success) {
			setInvoicePaid(true);
		}
		setTimeout(() => {
			refresh();
		}, 3000);
	}

	const returnUrl = window.location.href;
	const payment = usePaymentProcessor({
		purchase,
		stripeCustomer,
		detectedLocation,
		setPurchase,
		paymentResultCallback,
		returnUrl,
		cancelable:false
	});

	const refresh = async () => {
		window.location.reload();
	};
	
	let error = null;
	let createdDate = new Date(created);
	
	if (!props.invoice) {
		throw new Error("No invoice");
		return null;
	}
	
	let description = invoicePurchaseDescription(purchase, invoiceUser, institutionName);
	/*
	if (invoiceType == 'individual' && overQuota) {
		error = <Alert color='error'>Current usage exceeds the chosen plan&apos;s quota. You&apos;ll need to choose a larger storage plan, or delete some files from your Zotero storage.</Alert>;
	}
	*/
	let descriptionPs = description.map((d, i) => {
		return <p key={i}>{d}</p>;
	});
	
	let buttonLabel = `Continue`;
	
	let storageState = {};
	let callbacks = {};
	let Payment = null;
	if (!invoicePaid) {
		log.debug("invoice not yet paid");
		log.debug(description);
		
		callbacks = {
			setPurchase,
			refresh,
		};

		storageState = {
			payment,
			description,//multi-para description of update, whether charge or not
			stripeCustomer,
			purchase,
			error,
			// cancelable: false,
		}

		if (!props.summary) {
			Payment = (<PurchaseHandler title="Pay Invoice" />);
		}
	} else {
		if (!stripeChargeObject) {
			paymentSection = (
				<p>Payment is being processed</p>
			)
		} else {
			let paymentMethodDetails = stripeChargeObject.payment_method_details;
			log.debug(paymentMethodDetails);
			log.debug(stripeChargeObject);
			descriptionPs = <p>{stripeChargeObject.description}</p>;
			let datePaid = new Date(stripeChargeObject.created * 1000);
			
			if (paymentMethodDetails) {
				paymentSection = (
					<div className='currentPaymentMethod'>
						<Card>
							<CardHeader>
								<h3>Invoice Paid - {datePaid.toLocaleDateString('en-US', dateFormatOptions)}</h3>
							</CardHeader>
							<CardBody>
								<h4>Payment Method</h4>
								<PaymentMethod source={paymentMethodDetails} />
							</CardBody>
						</Card>
					</div>
				);
			}
		}
	}
	
	return (
		<ErrorWrapper>
			<StorageContext.Provider value={{storageState, callbacks}}>
			<div className='pay-invoice'>
				<Row>
					<Col sm={{ size: 4, offset: 2 }}>
						<h3>Invoice ID</h3>
						<p>{invoice.invoiceID}</p>
						<p>{createdDate.toLocaleDateString('en-US', dateFormatOptions)}</p>
					</Col>
					<Col sm={4}>
						<h3>Invoice For:</h3>
						<div id='user_info'>
							<p>{invoiceUser.username}</p>
							<p>{invoiceUser.email}</p>
							<p></p>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={{ size: 8, offset: 2 }}>
						<Notifier {...pageNotification} />
						<Card className='payment-card'>
							<CardHeader>Zotero Subscription Invoice</CardHeader>
							<CardBody>
								<LoadingSpinner className='m-auto' loading={operationPending} />
								<Card className='mb-4'>
									<CardBody>
										{error}
										{descriptionPs}
									</CardBody>
								</Card>
								{Payment}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
			</StorageContext.Provider>
		</ErrorWrapper>
	);
}

PayInvoice.propTypes = {
	invoice: PropTypes.shape({
		invoiceID: PropTypes.string.isRequired,
		invoiceType: PropTypes.string.isRequired,
		stripeCharge: PropTypes.string,
		userID: PropTypes.number,
		institutionID: PropTypes.number,
		numUsers: PropTypes.number,
		storageLevel: PropTypes.number,
		created: PropTypes.string
	}).isRequired,
	invoiceUser: PropTypes.shape({
		userID: PropTypes.number,
		username: PropTypes.string,
		email: PropTypes.string
	}),
	overQuota: PropTypes.bool,
	stripeCustomer: PropTypes.object,
	stripeChargeObject: PropTypes.shape({
		payment_method_details: PropTypes.object,
		created: PropTypes.number,
	}),
	institutionName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export { PayInvoice };
